import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, Row, Col, Button, Alert } from "react-bootstrap";
import TextLoading from "../TextLoading";

export default function ModalConfirmDelete(props) {
  const [t] = useTranslation(["global"]);
  const txtBtnAccept = props.txtBtnAccept || t("global:buttons.accept");
  const txtBtnCancel = props.txtBtnCancel || t("global:buttons.cancel");
  const fnCancelButton = props.fnCancelButton || false;
  const acceptButtonVariant = props.acceptButtonVariant || "primary";
  const loading = props.loading || false;
  const textLoading = props.textLoading || txtBtnAccept;

  return (
    <Modal
      id="modalSuccess"
      show={props.showModalDelete}
      size={props.size}
      aria-labelledby="contained-modal-title-md"
    >
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body mbottom10">
        <Row>
          <Col md={12} style={{ textAlign: "justify" }}>
            {props.message}
          </Col>
        </Row>
        {/**Errors */}
        {props.error && (
          <Row className="mt-3">
            <Col md={12}>
              <Alert variant="warning">{props.error}</Alert>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          {fnCancelButton && (
            <Button
              id="btnCancelModalSuccess"
              variant="outline-secondary"
              onClick={fnCancelButton}
              disabled={loading}
            >
              {txtBtnCancel}
            </Button>
          )}
          {props.fnAcceptButton && (
            <Button
              id="btnAcceptModalSuccess"
              variant={acceptButtonVariant}
              onClick={props.fnAcceptButton}
              disabled={loading}
            >
              {loading ? (
                <TextLoading text={textLoading} variant="white" />
              ) : (
                txtBtnAccept
              )}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ModalConfirmDelete.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  txtBtnAccept: PropTypes.string,
  fnAcceptButton: PropTypes.func,
  showModalDelete: PropTypes.bool,
  txtBtnCancel: PropTypes.string,
  fnCancelButton: PropTypes.func,
  acceptButtonVariant: PropTypes.string,
  loading: PropTypes.bool,
  textLoading: PropTypes.string,
  error: PropTypes.string,
};